<template>
  <div class="user-machine-line-product jt-table">
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :visible.sync="dialogUpgrade"
      width="50%"
      top="9vh"
      @closed="closeDialog"
      @open="openDialog"
      :close-on-click-modal="false"
    >
      <template #title>
        <div class="title_dialog" v-if="upgradeType == 1">
          {{ $t("upgrade.selectApk") }}
        </div>
        <div class="title_dialog" v-else>
          <span>{{ $t("upgrade.selectFirmware") }}</span>
          <span style="font-size: 14px; float: right; margin-right: 8%">
            {{ $t("upgrade.UpgradeVersion.257225-0") }}{{ rowInfo.apkVersion }}
          </span>
        </div>
      </template>
      <div style="width: 100%">
        <template v-if="isOneUpdate == 1">
          <!-- 一键升级 -->
          <div
            v-if="upgradeType == 1"
            @click="handleUpgradeType(2)"
            style="
              float: right;
              margin-left: 3%;
              text-align: right;
              margin-bottom: 10px;
              color: var(--vtm-mint-ink);
              cursor: pointer;
            "
          >
            {{ $t("upgrade.upgradeFirmware") }}
          </div>
          <div
            v-else
            @click="handleUpgradeType(1)"
            style="
              float: right;
              margin-left: 3%;
              text-align: right;
              margin-bottom: 10px;
              color: var(--vtm-mint-ink);
              cursor: pointer;
            "
          >
            {{ $t("upgrade.upgradeApk") }}
          </div>
        </template>
      </div>
      <el-form
        style="padding: 10px 0"
        label-position="left"
        v-loading="loading"
        :element-loading-text="$t('common.loading')"
        ref="updateVersion"
        :model="model"
        :align="'left'"
      >
        <!-- 筛选apk water -->
        <el-select
          v-if="upgradeType == 1 && pid == 0"
          size="small"
          style="width: 150px; margin-bottom: 10px"
          v-model="model.page.type"
          :placeholder="$t('advertGroupRela.select')"
          @change="handlerChange"
        >
          <el-option v-for="item in filterArr" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
        <el-table
          :empty-text="$t('common.noData')"
          :data="model.packages"
          @selection-change="handleSelectionChange"
          style="width: 100%"
          max-height="550"
        >
          <el-table-column :width="150" :label="$t('common.operate')" :align="'center'">
            <template slot-scope="scope">
              <el-radio :label="scope.$index" v-model="radio" @change="getCurrentRow(scope.row)" size="medium">
                V<span class="vtm-mono" v-if="upgradeType == 1">{{ scope.row.appVersion }}</span
                ><span class="vtm-mono" v-else>{{ scope.row.version }}</span>
              </el-radio>
            </template>
          </el-table-column>
          <el-table-column prop="fileName" :label="$t('upgrade.fileName')"></el-table-column>
          <el-table-column
            :width="100"
            :prop="type == 1 ? 'appVersion' : 'version'"
            :label="$t('upgrade.appVersion')"
          ></el-table-column>
          <el-table-column
            :width="150"
            v-if="upgradeType == 1"
            prop="versionState"
            :label="$t('upgrade.UpgradeVersion.257225-1')"
          >
            <template #default="scope">
              <el-tag type="success" v-if="scope.row.versionState == 1">{{
                $t("upgrade.UpgradeVersion.257225-2")
              }}</el-tag>
              <el-tag type="danger" v-else>{{ $t("upgrade.UpgradeVersion.257225-3") }}</el-tag>
            </template>
          </el-table-column>
        </el-table>

        <!-- 添加分页器 -->
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="currentChange"
          :current-page="model.page.pageIndex"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="model.page.pageSize"
          layout="total,sizes,prev,pager,next,jumper"
          :total="+model.page.total"
          style="margin-top: 10px; text-align: right"
        >
        </el-pagination>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancel('')">{{ $t("common.cancel") }}</el-button>
        <el-button size="small" type="primary" :disabled="loadingForm" @click="submitForm('updateVersion')">
          {{ $t("common.definite") }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "UpgradeVersion",
    props: {
      dialogUpgrade: Boolean,
      MachineNo: String,
      isOneUpdate: Boolean,
      upgradeType: Boolean,
      rowInfo: Object,
      isOneKey: Boolean
    },
    data() {
      return {
        filterArr: [
          {
            value: "1",
            label: "3.0"
          }
        ],
        loading: false,
        loadingForm: false,
        model: {
          packages: [],
          page: {
            type: "1",
            pageSize: 20,
            pageIndex: 1,
            uId: ""
          }
        },
        selectSet: {
          id: ""
        },
        radio: "",
        pid: ""
      };
    },
    mounted() {
      this.pid = localStorage.getItem("pId");
    },
    methods: {
      handlerChange() {
        this.currentChange();
      },
      // 选择信息
      getCurrentRow(val) {
        this.selectSet = val;
      },
      // 升级类型
      handleUpgradeType(type) {
        let _self = this;
        // 刷新内容
        _self.upgradeType = type;
        if (parseInt(type) == 2) {
          this.model.page.uId = "";
        }
        _self.openDialog(1);
      },
      // 关闭弹窗
      cancel(state) {
        this.$emit("cancel", false, state);
      },
      closeDialog() {
        this.cancel("");
      },
      openDialog(fuser = 0) {
        if (fuser == 0) {
          this.model.page.uId = "";
        }
        this.model.packages = [];
        this.model.page.pageIndex = 1;
        this.model.page.pageSize = 20;
        this.radio = "";
        this.selectSet = {};
        this.selectSet.id = "";
        this.currentChange();
      },
      currentChange(pageIndex) {
        this.loading = true;
        this.model.page.pageIndex = pageIndex || 1;
        let url = "";
        let rData = {};
        if (this.upgradeType == 1) {
          url = this.$url.Upgrade.listAppPage;
        } else if (this.upgradeType == 2) {
          url = this.$url.Upgrade.firmware;
          rData.apkId = this.rowInfo.apkId;
        }

        this.$api
          .request(url, this.$method.get, { ...this.model.page, ...rData })
          .then(res => {
            if (res.code === 0) {
              this.model.packages = res.data.records;
              this.model.page.total = res.data.total;
              this.model.page.pageIndex = res.data.pages;
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      },
      submitForm() {
        if (!this.selectSet.id) {
          this.$notify({
            title: this.$t("common.tip"),
            message: this.$t("upgrade.selectOne"),
            type: "error"
          });
          return false;
        }
        let equipmentNo = this.MachineNo;
        let versionId = this.selectSet.id;
        let machineNoSet = equipmentNo.split(",");
        if (this.upgradeType == 1) {
          // APP升级
          if (this.isOneKey) {
            // 一键升级
            this.$confirm(this.$t("upgrade.upgradeWarn"), this.$t("common.tip"), {
              confirmButtonText: this.$t("common.definite"),
              cancelButtonText: this.$t("common.cancel"),
              type: "warning"
            })
              .then(() => {
                this.loadingForm = true;
                let url = this.$url.Upgrade.appVersionMore;
                let method = this.$method.post;
                this.$api
                  .request(url, method, {
                    userEquipmentIds: machineNoSet,
                    apkId: versionId
                  })
                  .then(res => {
                    this.loadingForm = false;
                    this.cancel("APK");
                    if (res.code === 0) {
                      this.$notify({
                        title: this.$t("upgrade.sentTitle"),
                        message: this.$t("upgrade.apkSent"),
                        type: "success"
                      });
                    } else {
                      this.$notify({
                        title: this.$t("common.tip"),
                        message: res.msg,
                        type: "warning"
                      });
                    }
                  })
                  .catch(err => {
                    this.loadingForm = false;
                    this.$notify({
                      title: this.$t("common.tip"),
                      message: err.msg,
                      type: "error"
                    });
                  });
              })
              .catch(() => {});
          } else {
            // 单个升级
            this.$confirm(this.$t("upgrade.upgradeWarn"), this.$t("common.tip"), {
              confirmButtonText: this.$t("common.definite"),
              cancelButtonText: this.$t("common.cancel"),
              type: "warning"
            })
              .then(() => {
                this.loadingForm = true;
                let url = this.$url.Upgrade.appVersion;
                let method = this.$method.post;
                this.$api
                  .request(url, method, {
                    equipmentNo: equipmentNo,
                    apkId: versionId
                  })
                  .then(res => {
                    this.loadingForm = false;
                    this.cancel("APK");
                    if (res.code === 0) {
                      this.$notify({
                        title: this.$t("upgrade.sentTitle"),
                        message: this.$t("upgrade.apkSent"),
                        type: "success"
                      });
                    } else {
                      this.$notify({
                        title: this.$t("common.tip"),
                        message: res.msg,
                        type: "warning"
                      });
                    }
                  })
                  .catch(err => {
                    this.loadingForm = false;
                    this.$notify({
                      title: this.$t("common.tip"),
                      message: err.msg,
                      type: "error"
                    });
                  });
              })
              .catch(() => {});
          }
        } else {
          if (machineNoSet.length > 1) {
            // 一键升级
            this.$confirm(this.$t("upgrade.upgradeWarn"), this.$t("common.tip"), {
              confirmButtonText: this.$t("common.definite"),
              cancelButtonText: this.$t("common.cancel"),
              type: "warning"
            })
              .then(() => {
                this.loadingForm = true;
                let url = this.$url.Upgrade.firmwareVersionMore;
                let method = this.$method.post;
                this.$api
                  .request(url, method, {
                    userEquipmentIds: machineNoSet,
                    vmcId: versionId
                  })
                  .then(res => {
                    this.loadingForm = false;
                    this.cancel("VMC");
                    if (res.code === 0) {
                      this.$notify({
                        title: this.$t("upgrade.sentTitle"),
                        message: this.$t("upgrade.vmcSent"),
                        type: "success"
                      });
                    } else {
                      this.$notify({
                        title: this.$t("common.tip"),
                        message: res.msg,
                        type: "warning"
                      });
                    }
                  })
                  .catch(err => {
                    this.loadingForm = false;
                    this.$notify({
                      title: this.$t("common.tip"),
                      message: err.msg,
                      type: "error"
                    });
                  });
              })
              .catch(() => {});
          } else {
            // 单个升级
            this.$confirm(this.$t("upgrade.upgradeWarn"), this.$t("common.tip"), {
              confirmButtonText: this.$t("common.definite"),
              cancelButtonText: this.$t("common.cancel"),
              type: "warning"
            })
              .then(() => {
                this.loadingForm = true;
                let url = this.$url.Upgrade.firmwareVersion;
                let method = this.$method.post;
                this.$api
                  .request(url, method, {
                    equipmentNo: equipmentNo,
                    vmcId: versionId
                  })
                  .then(res => {
                    this.loadingForm = false;
                    this.cancel("VMC");
                    if (res.code === 0) {
                      this.$notify({
                        title: this.$t("upgrade.sentTitle"),
                        message: this.$t("upgrade.vmcSent"),
                        type: "success"
                      });
                    } else {
                      this.$notify({
                        title: this.$t("common.tip"),
                        message: res.msg,
                        type: "warning"
                      });
                    }
                  })
                  .catch(err => {
                    this.loadingForm = false;
                    this.$notify({
                      title: this.$t("common.tip"),
                      message: err.msg,
                      type: "error"
                    });
                  });
              })
              .catch(() => {});
          }
        }
      },
      handleSizeChange(val) {
        this.model.page.pageSize = val;
        this.model.page.pageIndex = 1;
        this.currentChange(1);
      }
    }
  };
</script>

<style lang="scss">
  .el-dialog__body {
    padding: 0 20px 15px 20px !important;
  }
  .image-slot {
    width: 34px;
    height: 34px;
    text-align: center;
    line-height: 34px;
    background-color: #f5f7fa;
    color: var(--vtm-ink-3);
    font-size: 12px;
  }
  [data-theme="dark"] .image-slot {
    background-color: var(--vtm-well);
  }
  .el-table .warning-row {
    background: #f2f6fc;
  }
  .demo .el-switch__label {
    position: absolute;
    display: none;
    color: #fff;
  }
  /*打开时文字位置设置*/
  .demo .el-switch__label--right {
    z-index: 1;
    right: -10px;
  }
  /*关闭时文字位置设置*/
  .demo .el-switch__label--left {
    z-index: 1;
    left: 34px;
  }
  /*显示文字*/
  .demo .el-switch__label.is-active {
    display: block;
  }
  .demo.el-switch .el-switch__core,
  .el-switch .el-switch__label {
    width: 60px !important;
    height: 28px !important;
    line-height: 28px;
    border-radius: 14px;
  }
  .user-machine-line-product .el-switch__core:after {
    width: 24px !important;
    height: 24px !important;
  }
  .user-machine-line-product .el-switch {
    height: 28px !important;
    padding-bottom: 3px;
  }
  .user-machine-line-product .el-switch.is-checked .el-switch__core::after {
    margin-left: -25px;
  }

  .user-machine-line-product .el-button--mini,
  .el-button--mini.is-round {
    padding: 8px 15px;
  }

  .title_dialog {
    line-height: 24px;
    font-size: 18px;
    color: var(--vtm-ink);
  }
</style>
